import axiosInstance from 'services/axiosInstance';
import { IResponse } from 'services/types';
import {
  IAutocomplete,
  ICreateCwTicketPayload,
  ICreateCwTicketResponse,
  ICWBoardStatus,
  ICWBoardType,
  ICWCompany,
  ICWContact,
  ICWServiceBoard,
  ICWSource,
} from 'services/connectwise/types';

export const getConnectwiseServiceBoards = (psaId: number): IResponse<ICWServiceBoard[]> =>
  axiosInstance.request({
    method: 'GET',
    url: `/Integration/${psaId}/service-boards`,
  });

export const getConnectwiseCompanies = (psaId: number): IResponse<ICWCompany[]> =>
  axiosInstance.request({
    method: 'GET',
    url: `/TicketCreate/${psaId}/connectwise/companies`,
  });

export const getConnectwiseSources = (psaId: number): IResponse<ICWSource[]> =>
  axiosInstance.request({ method: 'GET', url: `/Integration/${psaId}/sources` });

export const getConnectwisePriorities = (psaId: number): IResponse<IAutocomplete[]> =>
  axiosInstance.request({ method: 'GET', url: `/TicketCreate/${psaId}/connectwise/priorities` });

export const getConnectwiseContacts = (
  psaId: number,
  companyId?: number,
): IResponse<ICWContact[]> =>
  axiosInstance.request({
    method: 'GET',
    url: `/TicketCreate/${psaId}/contacts`,
    params: {
      companyId,
    },
  });

export const getConnectwiseSites = (psaId: number, companyId: number): IResponse<IAutocomplete[]> =>
  axiosInstance.request({
    method: 'GET',
    url: `/TicketCreate/${psaId}/connectwise/companies/${companyId}/sites`,
  });

export const getConnectwiseAgreements = (
  psaId: number,
  companyId: number,
): IResponse<IAutocomplete[]> =>
  axiosInstance.request({
    method: 'GET',
    url: `/TicketCreate/${psaId}/connectwise/companies/${companyId}/agreements`,
  });

export const getConnectwiseBoardStatuses = (
  psaId: number,
  boardId: number,
): IResponse<ICWBoardStatus[]> =>
  axiosInstance.request({
    method: 'GET',
    url: `/Integration/${psaId}/board-statuses/${boardId}`,
  });

export const getConnectwiseBoardTypes = (
  psaId: number,
  boardId: number,
): IResponse<ICWBoardType[]> =>
  axiosInstance.request({
    method: 'GET',
    url: `/Integration/${psaId}/board-types/${boardId}`,
  });

export const createCWTicket = (
  psaId: number,
  payload: ICreateCwTicketPayload,
): IResponse<ICreateCwTicketResponse> =>
  axiosInstance.request({
    method: 'POST',
    url: `/TicketCreate/${psaId}/connectwise/createTicket`,
    data: payload,
  });
